module.exports = __webpack_public_path__ + "img/a0309_3.4ba36251.png";